import api from './api';

const auditoriaService = {
  // Listar registros de auditoria com filtros
  async listar(params = {}) {
    const response = await api.get('/auditoria', { params });
    return response.data;
  },

  // Buscar auditoria por entidade
  async buscarPorEntidade(entidade, id) {
    const response = await api.get(`/auditoria/entidade/${entidade}/${id}`);
    return response.data;
  },

  // Buscar auditoria por usuário
  async buscarPorUsuario(id_usuario, params = {}) {
    const response = await api.get(`/auditoria/usuario/${id_usuario}`, { params });
    return response.data;
  },

  // Buscar estatísticas
  async estatisticas(params = {}) {
    const response = await api.get('/auditoria/estatisticas', { params });
    return response.data;
  }
};

export default auditoriaService;
